import { useContext, type JSX } from 'react';

import { SearchFormTemplate } from '@/widgets/Templates/SearchFormTemplate';

import TattooSearchSchema from '@/shared/data/schemas/services/RMPTATU.json';

import { ServiceNames } from '@/config/services';

import { ServicesContext } from '@/contexts/Services/ServicesContext';

import { SERVICE_CODES } from '@/lib/consts';

import { RmpcTattooShort } from '@/api/integrations/rmpc/types/types';

import { TattooSearchContext } from '../../context/TattooSearchContext';
import { TattooCardItem } from '../TattooCardItem';
import { TattooSearchClearButton } from '../TattooSearchClearButton';
import { TattooSearchPagination } from '../TattooSearchPagination';

import type { Schema } from '@/widgets/FormBuilder/types';
import type { ResultViewProps } from '@/widgets/Templates/SearchFormTemplate/model/types';

export const TattooSearchForm: React.FC = () => {
  const { handleSearch, isLoading, isFetching, hasBeenFetched, result, getContextDictionaries } =
    useContext(TattooSearchContext);
  const { getServiceByCode } = useContext(ServicesContext);
  const dictionaries = getContextDictionaries();

  const resultType: ResultViewProps<RmpcTattooShort> = {
    type: 'card' as const,
    className: 'tattoo-search-results',
    render: (tattoo: RmpcTattooShort): JSX.Element => <TattooCardItem item={tattoo} />,
  };

  const renderPagination = (): JSX.Element => <TattooSearchPagination />;
  const renderClearButton = (onClear: () => void): JSX.Element => <TattooSearchClearButton onClear={onClear} />;

  return (
    <SearchFormTemplate
      serviceName={getServiceByCode(SERVICE_CODES.TATTOO_SEARCH)?.documentName ?? ServiceNames.RMPTATU}
      formTitle="Фільтрація за характеристиками"
      formSchema={TattooSearchSchema as unknown as Schema}
      formSubmit={handleSearch}
      isLoading={isLoading}
      isFetching={isFetching}
      hasBeenFetched={hasBeenFetched}
      result={result}
      resultType={resultType}
      renderPagination={renderPagination}
      renderClearButton={renderClearButton}
      dictionaries={dictionaries}
    />
  );
};
